import React from "react";
import * as SC from "./PrintPostEditorGoogleSearch.styled";

import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor";

import TextEditor from "../../../../Previews/TextEditor/index";
import { channelsByShortName } from "../../../../../../data/app__channels";
import { GoogleBannedCharacters } from "./utils";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import { useTranslation } from "react-i18next";

const PrintPostEditorGoogleSearch = ({
  postData,
  channelData,
  updatePost,
  updateChannelData,
  mobile,
  editable
}) => {
  const channel = channelsByShortName["google-search"];
  const { t } = useTranslation();

  return (
    <SC.PostEditorWrapper mobile={mobile}>
      {mobile && <SC.MobileTop src="/images/mobile-top.png" alt="" />}

      <div style={{ display: "flex" }}>
        {mobile && <SC.MobileSide src="/images/mobile-left.png" alt="" />}

        <SC.MobileContent mobile={mobile}>
          {mobile && <SC.MobileSearch src="/images/google_search_mobile_search.png" alt="" />}

          <SC.GoogleSearchEditorWrapper mobile={mobile}>
            <SC.GoogleSearchEditor mobile={mobile}>
              <TextEditor
                name="title"
                label={t("Job Title")}
                value={postData.title}
                maxLength={channel.limits.title}
                editable={editable}
                postNumber={postData.postNumber}
                updatePost={updatePost}
                updateChannelData={updateChannelData}
              />

              <TextEditor
                name="title2"
                label="Headline 2"
                value={postData.title2}
                maxLength={channel.limits.title}
                editable={editable}
                postNumber={postData.postNumber}
                updatePost={updatePost}
                updateChannelData={updateChannelData}
              />

              <TextEditor
                name="title3"
                label="Headline 3"
                value={postData.title3}
                maxLength={channel.limits.title}
                editable={editable}
                postNumber={postData.postNumber}
                updatePost={updatePost}
                updateChannelData={updateChannelData}
              />

              <SC.LinkWrapper>
                <SC.AdBox>Ad</SC.AdBox>
                <PrintCampaignCreateChannelDataEditor
                  updateChannelData={updateChannelData}
                  value={channelData.url}
                  dataKey="url"
                  textStyle={SC.urlStyle}
                  ellipsis
                  label="URL"
                  tooltip="URL"
                  editable={editable}
                  urlValue={channelData.url}
                  padding="2px 4px"
                />
              </SC.LinkWrapper>
              <SC.Line />
              <PrintCampaignCreateTeaserEditor
                channel="google-search"
                updatePost={updatePost}
                teaserText={postData.teaserText}
                editable={editable}
                teaserTextStyle={SC.teaserTextStyle}
                limit={channelsByShortName["google-search"].limits.teaserText}
                minRows={1}
                padding="2px 6px"
                smallButtons={mobile}
                disableEmojis
                isAutoGenerated={postData?.isAutoGenerated}
                autoGeneratedText={postData?.autoGeneratedText}
                isEdited={postData?.editedStates?.teaserText}
                bannedCharaters={GoogleBannedCharacters}
                rejectPhoneNumbers
              />
              <SC.Line />
              <PrintCampaignCreateTeaserEditor
                channel="google-search"
                updatePost={updatePost}
                teaserText={postData.teaserText2 || ""}
                editable={editable}
                postDataKey="teaserText2"
                teaserTextStyle={SC.teaserTextStyle}
                limit={channelsByShortName["google-search"].limits.teaserText}
                minRows={1}
                padding="2px 6px"
                smallButtons={mobile}
                disableEmojis
                isEdited={postData?.editedStates?.teaserText}
                bannedCharaters={GoogleBannedCharacters}
                rejectPhoneNumbers
              />
            </SC.GoogleSearchEditor>
          </SC.GoogleSearchEditorWrapper>
        </SC.MobileContent>
        {mobile && <SC.MobileSide src="/images/mobile-right.png" alt="" />}
      </div>
      {mobile && <SC.MobileBottom src="/images/mobile-bottom.png" alt="" />}
    </SC.PostEditorWrapper>
  );
};

export default PrintPostEditorGoogleSearch;
